// firebase.js
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore,getDoc,doc } from "firebase/firestore";
import { getAuth, } from "firebase/auth";
import { getStorage } from 'firebase/storage';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


const firebaseConfig = {
    apiKey: "AIzaSyDKpKWWviXGgT9R5FadvLIPovL7fTjN0l4",
    authDomain: "ordermaster-decee.firebaseapp.com",
    projectId: "ordermaster-decee",
    storageBucket: "ordermaster-decee.appspot.com",
    messagingSenderId: "917398525512",
    appId: "1:917398525512:web:7b26d9b756d2f37d4e2a7d",
    measurementId: "G-GV4RW8L5LF"
  };

// Initialize Firebase
const app=initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const messaging = getMessaging(app);

// Initialize Firestore and Auth
const db = getFirestore(app);
const auth = getAuth(app);

//export { db, auth };

// Initialize Firebase Storage
const storage = getStorage(app);

const requestFirebaseNotificationPermission = async () => {
  try {
    const token = await getToken(messaging, {
      vapidKey: 'BJn_gs_RPsq6b8mMENsdwPIZrnT_MqZRfO5ORi_TrJkhb0u4XH6S3YwJxx4tgUZu66MIpxAbyctOobGIfK0QNpM',
    });
    //console.log('FCM Token:', token);
    return token;
  } catch (error) {
    console.error('Error getting FCM token:', error);
    return null;
  }
};

const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

  navigator.serviceWorker
  .register('/firebase-messaging-sw.js')
  .then((registration) => {
    console.log('Firebase Messaging Service Worker registered:', registration);
  });

export { app,db,auth,storage,requestFirebaseNotificationPermission,onMessageListener };
